import { render, staticRenderFns } from "./ellipsoid.vue?vue&type=template&id=c2128792&scoped=true&"
import script from "./ellipsoid.vue?vue&type=script&lang=js&"
export * from "./ellipsoid.vue?vue&type=script&lang=js&"
import style0 from "./ellipsoid.vue?vue&type=style&index=0&id=c2128792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2128792",
  null
  
)

export default component.exports